/* Lotus Edition holiday looks. Picks today's holiday by date, recolors the site,
   adds a greeting band and a short (5 second) festive effect. Preview any look with ?lx_holiday=key. */
(function () {
  var root = document.documentElement;

  /* Colors per look. a = buttons and header, d = hover, l = light highlight. All checked for 4.5:1 contrast. */
  var LOOK = {
    navratri:     { a: '#9C1F5E', d: '#7E1849', l: '#F7B32B', m: 'marigold', fx: 'petals',   c: ['#F7B32B', '#E8590C', '#D6336C'] },
    dussehra:     { a: '#9E3A0A', d: '#7F2E08', l: '#F7B32B', m: 'marigold', fx: 'petals',   c: ['#F7B32B', '#E8590C', '#FFD43B'] },
    diwali:       { a: '#7A1F2B', d: '#5E1721', l: '#F2C14E', m: 'diya',     fx: 'sparkle',  c: ['#F2C14E', '#FFD43B', '#F08C00'] },
    halloween:    { a: '#8F3A06', d: '#702D05', l: '#F7A541', m: 'pumpkin',  fx: 'leaves',   c: ['#E8590C', '#5F3DC4', '#F7A541'] },
    thanksgiving: { a: '#6E4318', d: '#553312', l: '#E8A33D', m: 'leaf',     fx: 'leaves',   c: ['#C2410C', '#E8A33D', '#8F3A06'] },
    blackfriday:  { a: '#1A1A1A', d: '#000000', l: '#F4C542', m: 'star',     fx: 'sparkle',  c: ['#F4C542', '#E5C878', '#FFFFFF'] },
    holidays:     { a: '#1F5C3A', d: '#174A2E', l: '#E5C878', m: 'snow',     fx: 'snow',     c: ['#A5C8E4', '#DCE9F5', '#C9A45C'] },
    newyear:      { a: '#1C2B4A', d: '#141F36', l: '#E5C878', m: 'star',     fx: 'confetti', c: ['#E5C878', '#C9A45C', '#8FA8D6'] },
    sankranti:    { a: '#8C3A0E', d: '#6F2E0B', l: '#F6B940', m: 'kite',     fx: 'confetti', c: ['#F6B940', '#E8590C', '#1C7ED6'] },
    valentine:    { a: '#A3213F', d: '#831A33', l: '#F7B6C6', m: 'heart',    fx: 'hearts',   c: ['#E64980', '#F7B6C6', '#C2255C'] },
    holi:         { a: '#7B2C8F', d: '#622372', l: '#F6A6D1', m: 'dots',     fx: 'confetti', c: ['#E64980', '#FAB005', '#15AABF', '#40C057', '#7950F2'] },
    stpatrick:    { a: '#1E6B3A', d: '#17552E', l: '#B8E07A', m: 'shamrock', fx: 'confetti', c: ['#2F9E44', '#8CE99A', '#FAB005'] },
    easter:       { a: '#5E4691', d: '#4A3773', l: '#D9C8F2', m: 'egg',      fx: 'petals',   c: ['#D9C8F2', '#FFC9DE', '#C3FAE8'] },
    mothers:      { a: '#963B60', d: '#782F4D', l: '#F4B8CF', m: 'flower',   fx: 'petals',   c: ['#F4B8CF', '#E64980', '#FFDEEB'] },
    memorial:     { a: '#1F3A6B', d: '#172C52', l: '#E8C468', m: 'star',     fx: 'none',     c: [] },
    fathers:      { a: '#2F4858', d: '#243846', l: '#C9D8E2', m: 'star',     fx: 'none',     c: [] },
    july4:        { a: '#1F3A6B', d: '#172C52', l: '#F2C14E', m: 'star',     fx: 'confetti', c: ['#C92A2A', '#1F3A6B', '#FFFFFF', '#F2C14E'] },
    rakhi:        { a: '#9A3F12', d: '#7B320E', l: '#F6B940', m: 'rakhi',    fx: 'petals',   c: ['#F6B940', '#E64980', '#F08C00'] },
    ganesh:       { a: '#A0420B', d: '#803509', l: '#F6B940', m: 'marigold', fx: 'petals',   c: ['#F6B940', '#E8590C', '#D6336C'] },
    labor:        { a: '#1F3A6B', d: '#172C52', l: '#E8C468', m: 'star',     fx: 'none',     c: [] }
  };

  /* Dated windows (inclusive). Earlier rows win when dates overlap. */
  var DATED = [
    ['2026-10-11', '2026-10-19', 'navratri', 'Happy Navratri! Festive jewelry for every garba night'],
    ['2026-10-20', '2026-10-20', 'dussehra', 'Happy Dussehra! Celebrating the victory of good'],
    ['2026-10-21', '2026-10-27', 'diwali', 'Diwali is Sunday, Nov 8. Find your festive sparkle'],
    ['2026-11-01', '2026-11-05', 'diwali', 'Diwali is Sunday, Nov 8. Find your festive sparkle'],
    ['2026-11-06', '2026-11-09', 'diwali', 'Happy Diwali! Shine bright this festival of lights'],
    ['2027-01-13', '2027-01-15', 'sankranti', 'Happy Makar Sankranti, Pongal and Lohri'],
    ['2027-03-18', '2027-03-22', 'holi', 'Happy Holi! Celebrate every color'],
    ['2027-08-12', '2027-08-17', 'rakhi', 'Happy Raksha Bandhan'],
    ['2027-08-31', '2027-09-04', 'ganesh', 'Happy Ganesh Chaturthi! Ganpati Bappa Morya'],
    ['2027-09-30', '2027-10-08', 'navratri', 'Happy Navratri! Festive jewelry for every garba night'],
    ['2027-10-09', '2027-10-09', 'dussehra', 'Happy Dussehra! Celebrating the victory of good'],
    ['2027-10-10', '2027-10-26', 'diwali', 'Diwali is Friday, Oct 29. Find your festive sparkle'],
    ['2027-10-27', '2027-10-30', 'diwali', 'Happy Diwali! Shine bright this festival of lights']
  ];

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function add(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate() + n); return x; }
  function nth(y, m, wd, n) { var d = new Date(y, m, 1); while (d.getDay() !== wd) d = add(d, 1); return add(d, 7 * (n - 1)); }
  function lastWd(y, m, wd) { var d = new Date(y, m + 1, 0); while (d.getDay() !== wd) d = add(d, -1); return d; }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), mo = Math.floor((h + l - 7 * m + 114) / 31);
    return new Date(y, mo - 1, ((h + l - 7 * m + 114) % 31) + 1);
  }
  function yearly(y) {
    var tg = nth(y, 10, 4, 4), md = nth(y, 4, 0, 2), mem = lastWd(y, 4, 1), fd = nth(y, 5, 0, 3), lab = nth(y, 8, 1, 1), ea = easter(y);
    return [
      [y + '-01-01', y + '-01-02', 'newyear', 'Happy New Year from Lotus Edition'],
      [y + '-02-07', y + '-02-14', 'valentine', 'Gifts for your Valentine'],
      [y + '-03-14', y + '-03-17', 'stpatrick', "Happy St. Patrick's Day"],
      [ymd(add(ea, -3)), ymd(ea), 'easter', 'Happy Easter from Lotus Edition'],
      [ymd(add(md, -7)), ymd(md), 'mothers', "Gifts for Mom this Mother's Day"],
      [ymd(add(mem, -2)), ymd(mem), 'memorial', 'Honoring those who served this Memorial Day'],
      [ymd(add(fd, -6)), ymd(fd), 'fathers', "Happy Father's Day"],
      [y + '-06-29', y + '-07-04', 'july4', 'Happy 4th of July!'],
      [ymd(add(lab, -2)), ymd(lab), 'labor', 'Happy Labor Day weekend'],
      [y + '-10-28', y + '-10-31', 'halloween', 'Happy Halloween from Lotus Edition'],
      [ymd(add(tg, -6)), ymd(tg), 'thanksgiving', 'Happy Thanksgiving! Thankful for you'],
      [ymd(add(tg, 1)), ymd(add(tg, 4)), 'blackfriday', 'Holiday shopping is here. Find a gift they will love'],
      [y + '-12-01', y + '-12-23', 'holidays', 'Happy Holidays from Lotus Edition'],
      [y + '-12-24', y + '-12-26', 'holidays', 'Merry Christmas from Lotus Edition'],
      [y + '-12-27', y + '-12-31', 'newyear', 'Happy New Year from Lotus Edition']
    ];
  }

  var today = ymd(new Date()), pick = null, forced = null;
  try { forced = new URLSearchParams(location.search).get('lx_holiday'); } catch (e) {}
  if (forced === 'off') return;
  if (forced && LOOK[forced]) {
    pick = [today, today, forced, 'Preview: ' + forced + ' look'];
    var all = DATED.concat(yearly(new Date().getFullYear()), yearly(new Date().getFullYear() + 1));
    for (var f = 0; f < all.length; f++) if (all[f][2] === forced) { pick = all[f]; break; }
  } else {
    var list = DATED.concat(yearly(new Date().getFullYear()));
    for (var i = 0; i < list.length; i++) if (today >= list[i][0] && today <= list[i][1]) { pick = list[i]; break; }
  }
  if (!pick) return;
  var key = pick[2], L = LOOK[key];
  root.setAttribute('data-lx-holiday', key);

  /* Colors: only in the default light look, so shopper-picked palettes and dark mode stay as chosen */
  var sel = 'html[data-lx-holiday]:not([data-lx-palette]):not([data-lx-theme=dark]) .lx-root';
  var st = document.createElement('style');
  st.textContent = sel + '{--sage:' + L.a + ';--sage-deep:' + L.d + ';--gold:' + L.a + ';--lime:' + L.l + ';--gold-soft:' + L.l + '}' +
    '.lx-hol{display:flex;align-items:center;justify-content:center;gap:14px;padding:10px 16px;background:' + L.a + ';color:#FFFFFF;text-align:center;font:500 .95rem/1.4 var(--body,system-ui,sans-serif);letter-spacing:.02em}' +
    '.lx-hol__text{margin:0}' +
    '.lx-hol__deco{flex:1 1 0;max-width:260px;height:24px;background-repeat:repeat-x;background-position:center;background-size:24px 24px}' +
    '@media (max-width:600px){.lx-hol{font-size:.85rem;padding:8px 12px}.lx-hol__deco{max-width:48px}}';
  document.head.appendChild(st);

  /* Small motif drawings, repeated along the greeting band */
  var M = {
    marigold: '<g><circle cx="12" cy="12" r="7" fill="#F7B32B"/><circle cx="12" cy="12" r="4.5" fill="#F08C00"/><circle cx="12" cy="12" r="2" fill="#C2410C"/></g>',
    diya: '<path d="M4 13h16c-1 4-4 6-8 6s-7-2-8-6z" fill="#F2C14E"/><path d="M12 4c2 3 2 5 0 7-2-2-2-4 0-7z" fill="#FFD43B"/>',
    pumpkin: '<ellipse cx="12" cy="14" rx="8" ry="6" fill="#F08C00"/><path d="M12 8V5" stroke="#2B8A3E" stroke-width="2"/>',
    leaf: '<path d="M12 3c5 3 7 8 4 13-2 3-6 4-8 2-3-4-1-11 4-15z" fill="#E8A33D"/><path d="M8 19L14 8" stroke="#8F3A06" stroke-width="1.2"/>',
    snow: '<path d="M12 3v18M4.2 7.5l15.6 9M4.2 16.5l15.6-9" stroke="#FFFFFF" stroke-width="1.6" stroke-linecap="round"/>',
    star: '<path d="M12 3l2.6 5.6 6.1.6-4.6 4.1 1.3 6-5.4-3.1-5.4 3.1 1.3-6-4.6-4.1 6.1-.6z" fill="' + L.l + '"/>',
    kite: '<path d="M12 3l6 8-6 8-6-8z" fill="#F6B940"/><path d="M12 19v3" stroke="#FFFFFF" stroke-width="1.4"/>',
    heart: '<path d="M12 20s-7-4.4-7-9.5A4 4 0 0 1 12 8a4 4 0 0 1 7 2.5C19 15.6 12 20 12 20z" fill="#F7B6C6"/>',
    dots: '<circle cx="6" cy="9" r="3" fill="#FAB005"/><circle cx="14" cy="7" r="3" fill="#15AABF"/><circle cx="11" cy="16" r="3" fill="#F6A6D1"/><circle cx="19" cy="15" r="2.5" fill="#40C057"/>',
    shamrock: '<circle cx="12" cy="8" r="3.5" fill="#B8E07A"/><circle cx="8" cy="13" r="3.5" fill="#B8E07A"/><circle cx="16" cy="13" r="3.5" fill="#B8E07A"/><path d="M12 13v8" stroke="#B8E07A" stroke-width="1.6"/>',
    egg: '<ellipse cx="12" cy="13" rx="6" ry="8" fill="#D9C8F2"/><path d="M6.5 12h11" stroke="#FFC9DE" stroke-width="2"/>',
    flower: '<g fill="#F4B8CF"><circle cx="12" cy="7" r="3.2"/><circle cx="17" cy="11" r="3.2"/><circle cx="15" cy="17" r="3.2"/><circle cx="9" cy="17" r="3.2"/><circle cx="7" cy="11" r="3.2"/></g><circle cx="12" cy="12.5" r="2.4" fill="#FAB005"/>',
    rakhi: '<circle cx="12" cy="12" r="5" fill="#F6B940"/><circle cx="12" cy="12" r="2.2" fill="#E64980"/><path d="M2 12h5M17 12h5" stroke="#FFFFFF" stroke-width="1.6"/>'
  };
  function deco() {
    var s = document.createElement('span');
    s.className = 'lx-hol__deco';
    s.setAttribute('aria-hidden', 'true');
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">' + (M[L.m] || M.star) + '</svg>';
    s.style.backgroundImage = 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '")';
    return s;
  }
  function band() {
    if (document.querySelector('.lx-hol')) return;
    var host = document.querySelector('main#MainContent');
    if (!host) return;
    var b = document.createElement('div');
    b.className = 'lx-hol';
    b.setAttribute('role', 'note');
    var p = document.createElement('p');
    p.className = 'lx-hol__text';
    p.textContent = pick[3];
    b.appendChild(deco()); b.appendChild(p); b.appendChild(deco());
    host.insertBefore(b, host.firstChild);
  }

  /* Short festive effect: plays once per visit for 5 seconds, never when reduced motion is on */
  function effect() {
    if (L.fx === 'none' || !L.c.length) return;
    if (root.hasAttribute('data-a11y-motion')) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches && !forced) return;
    try { if (!forced && sessionStorage.getItem('lx_hol_fx') === key) return; sessionStorage.setItem('lx_hol_fx', key); } catch (e) {}
    var cv = document.createElement('canvas');
    if (!cv.getContext || !window.requestAnimationFrame) return;
    cv.setAttribute('aria-hidden', 'true');
    cv.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:45';
    document.body.appendChild(cv);
    var ctx = cv.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2), W = innerWidth, H = innerHeight;
    cv.width = W * dpr; cv.height = H * dpr; ctx.scale(dpr, dpr);
    var n = W < 600 ? 28 : 55, parts = [];
    for (var j = 0; j < n; j++) parts.push({ x: Math.random() * W, y: -Math.random() * H * 0.6, s: 5 + Math.random() * 7, vy: 1.2 + Math.random() * 1.8, vx: -0.6 + Math.random() * 1.2, r: Math.random() * 6.28, vr: -0.05 + Math.random() * 0.1, c: L.c[j % L.c.length] });
    function shape(q) {
      ctx.save(); ctx.translate(q.x, q.y); ctx.rotate(q.r); ctx.fillStyle = q.c; ctx.strokeStyle = q.c; ctx.beginPath();
      if (L.fx === 'snow') { ctx.globalAlpha *= 0.9; ctx.arc(0, 0, q.s / 2.5, 0, 6.28); ctx.fill(); }
      else if (L.fx === 'hearts') { var s = q.s / 2; ctx.moveTo(0, s); ctx.bezierCurveTo(-s * 2, -s * 0.4, -s * 0.6, -s * 1.6, 0, -s * 0.5); ctx.bezierCurveTo(s * 0.6, -s * 1.6, s * 2, -s * 0.4, 0, s); ctx.fill(); }
      else if (L.fx === 'leaves' || L.fx === 'petals') { ctx.ellipse(0, 0, q.s * 0.75, q.s * 0.35, 0, 0, 6.28); ctx.fill(); }
      else if (L.fx === 'sparkle') { var t = q.s / 2; ctx.moveTo(0, -t); ctx.lineTo(t * 0.3, -t * 0.3); ctx.lineTo(t, 0); ctx.lineTo(t * 0.3, t * 0.3); ctx.lineTo(0, t); ctx.lineTo(-t * 0.3, t * 0.3); ctx.lineTo(-t, 0); ctx.lineTo(-t * 0.3, -t * 0.3); ctx.closePath(); ctx.fill(); }
      else { ctx.fillRect(-q.s / 2, -q.s / 4, q.s, q.s / 2); }
      ctx.restore();
    }
    var t0 = 0, end = 5000;
    function frame(t) {
      if (!t0) t0 = t;
      var age = t - t0;
      ctx.clearRect(0, 0, W, H);
      ctx.globalAlpha = age > end - 800 ? Math.max(0, (end - age) / 800) : 1;
      for (var k = 0; k < parts.length; k++) { var q = parts[k]; q.y += q.vy; q.x += q.vx + Math.sin((t + k * 300) / 600) * 0.4; q.r += q.vr; shape(q); }
      if (age < end) requestAnimationFrame(frame); else cv.remove();
    }
    requestAnimationFrame(frame);
  }

  function go() { band(); effect(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
